import { handleRequest } from "../utilities/requestHandler";

export const getDocumentCategories = () =>
    handleRequest("get", "/documents/categories");

export const getDocuments = (siteId) =>
    handleRequest("post", "/documents/getDocuments", {
        site_id: siteId,
    });


export const downloadDocument = (documentName) =>
  handleRequest(
    "get",
    `/documents/downloadDocument/${documentName}`,
    null,
    { responseType: "blob" }
  );  
export const getDocumentsMetaData = (siteId) =>
    handleRequest("post", "/documents/getDocumentsMetaData", {
        site_id: siteId,
    });

export const uploadDocument = (formData) =>
    handleRequest("post", "/documents/uploadDocument", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

export const updateDocument = (documentId, formData) =>
	handleRequest("put", `/documents/update/${documentId}`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

export const deleteDocument = (documentId) =>
    handleRequest("delete", `/documents/deleteDocument/${documentId}`);

export const searchMachines = (searchQuery, page, limit = 50) =>
    handleRequest("post", "/machines/search", { q: searchQuery, page, limit });

export const getDocumentAudience = (payload) =>
	handleRequest("post", "/documents/audience", payload);

export const createDocumentCategory = (payload) =>
	handleRequest("post", "/documents/categories", payload);

export const updateDocumentCategory = (categoryId, payload) =>
	handleRequest("put", `/documents/categories/${categoryId}`, payload);

export const deleteDocumentCategory = (categoryId, payload = {}) =>
	handleRequest("delete", `/documents/categories/${categoryId}`, payload);

export const updateCategoryDocuments = (categoryId, payload) =>
	handleRequest("post", `/documents/categories/${categoryId}/documents`, payload);
